import clientApi from "@/services/byLawViewerAPI";

export default {
    applyFilter: ({ state, commit }, ids) => {
        
    },
    cancelFilter:({ commit }) => {
       
    }
};
